/**
* @ngdoc component
* @name help.component:itxStoreInfo
* @description
* Store information
*/
(function() {
    'use strict';

    var itxStoreInfo = {
        bindings: {
            store: '<',
            callButton: '<',
        },
        require: {
            parent: '^itxStoreLocator',
        },        
        controllerAs: '$ctrl',
        controller:   ItxStoreInfoCtrl,
        templateUrl: 'store-info.component.html'
    };

    ItxStoreInfoCtrl.$inject = [
        'ItxScreenSizeSvc',
        'ItxStoreLocatorSvc'
    ];

    function ItxStoreInfoCtrl (
        ItxScreenSizeSvc,
        ItxStoreLocatorSvc
    ) {
        var _this = this;

        _this.$onInit = function () {
            // Translation texts.
            _this.text = ItxStoreLocatorSvc.getTranslations(_this.searchType);
        };

        _this.storeSelected=function(){
            return _this.store && ItxScreenSizeSvc.is('xs,sm');
        };

        _this.selectStore=function(store){
            _this.parent.selectStore(store);
        };

        _this.toggleFavouriteStore=function(store, $event){
            _this.parent.toggleFavouriteStore(store, $event);
        };

        _this.isDroppointSearch =function(){
            return ItxStoreLocatorSvc.isDroppointSearch();
        };

        _this.getRelatedInfo=function(store){
            return _this.parent.getRelatedInfo(store);
        };
    }

    angular.module('itxApp.common')
    .component('itxStoreInfo',itxStoreInfo);

})();